/**
 * Quiet toast chrome - gallery SoT `/?test=maater-ui#toasts`.
 *
 * Neutral card, tone on the icon only, compact width, quiet text action,
 * hover close chip. Styles: `styles/features/_toast-chrome.scss`.
 */
import type { ExternalToast } from 'sonner'

export const QUIET_TOAST_CLASS = 'maater-quiet-toast'

/** Hover pauses the timer (Sonner default), so these can stay short. */
export const QUIET_TOAST_DURATION_MS = {
  success: 3000,
  /** Undo / Open actions need a beat longer - never 30s. */
  withAction: 8000,
  info: 5000,
  error: 8000,
} as const

export type QuietToastTone = keyof typeof QUIET_TOAST_DURATION_MS

export function quietToastOptions(
  tone: QuietToastTone,
  options: ExternalToast = {},
): ExternalToast {
  const hasAction = Boolean(options.action)
  return {
    closeButton: true,
    duration: hasAction && tone === 'success'
      ? QUIET_TOAST_DURATION_MS.withAction
      : QUIET_TOAST_DURATION_MS[tone],
    ...options,
    className: [QUIET_TOAST_CLASS, options.className].filter(Boolean).join(' '),
  }
}
